import React from 'react'
import { ReactComponent as Refresh } from '../../assets/icons/icon-refresh.svg'
import { ReactComponent as Back } from '../../assets/icons/icon-arrow-back.svg'
import { ReactComponent as UpArrow } from '../../assets/icons/icon-arrow-up.svg'
import { ReactComponent as DownArrow } from '../../assets/icons/icon-arrow-down.svg'
import { ReactComponent as OpenInNew } from '../../assets/icons/icon-open-in-new.svg'
import { ReactComponent as ExternalLink } from '../../assets/icons/icon-external.svg'
import { ReactComponent as DefaultIcon } from '../../assets/icons/icon-broken-image.svg'
import { ReactComponent as NavigationIcon } from '../../assets/icons/icon-navigation.svg'

const Icon = ({ icon, className }) => {
  let IconComponent
  switch (icon) {
    case 'openInNew':
      IconComponent = OpenInNew
      break
    case 'refresh':
      IconComponent = Refresh
      break
    case 'back':
      IconComponent = Back
      break
    case 'external':
      IconComponent = ExternalLink
      break
    case 'navigation':
      IconComponent = NavigationIcon
      break
    case 'upArrow':
      IconComponent = UpArrow
      break
    case 'downArrow':
      IconComponent = DownArrow
      break
    default:
      IconComponent = DefaultIcon
  }
  return <IconComponent className={`${className} fill-current`} />
}

export default Icon
